import { useNotification } from '@/context/notification';
import {
  CertificateSources,
  useGetCertificateUrl,
} from '@/data/courses/certificate';

export const useGenerateCertificate = (courseId: string) => {
  const { mutate: getCertificateUrl, isPending: loadingCertificate } =
    useGetCertificateUrl(courseId, CertificateSources.Lms);
  const { toast } = useNotification();

  const onError = () => {
    toast({
      content: 'Não foi possível gerar o certificado.',
      type: 'error',
    });
  };

  const viewCertificate = () => {
    getCertificateUrl(undefined, {
      onSuccess: ({ data }) => {
        if (!data?.certificate_url) {
          onError();
          return;
        }
        window.open(data.certificate_url, '_blank');
      },
      onError,
    });
  };

  return {
    viewCertificate,
    loadingCertificate,
  };
};
